import React, {useState, useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {fetchFile, getCourseById} from '../apiConfig/services';
import {ChevronLeft} from "@mui/icons-material";
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

function VideoDetails() {
    const {videoId} = useParams(); // Get video ID from URL
    const [video, setVideo] = useState(null);
    const [coverUrl, setCoverUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [videoUrl, setVideoUrl] = useState(''); // State for the video URL
    const navigate = useNavigate();

    useEffect(() => {
        const fetchVideoDetails = async () => {
            setLoading(true);
            try {
                const videoData = await getCourseById(videoId);
                if (videoData) {
                    setVideo(videoData);
                    if (videoData.cover_course) {
                        const cover = await fetchFile(videoData.cover_course, 'couverture');
                        setCoverUrl(cover || '');
                    }
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching video details', error);
                setLoading(false);
            }
        };

        fetchVideoDetails();
    }, [videoId]);

    const handleBackClick = () => {
        navigate(-1);
    };

    const lireVideo = (file, type) => {
        // Update the videoUrl state with the video link
        setVideoUrl(video.links.url_link);
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="spinner"></div>
            </div>
        );
    }

    if (!video) {
        return <p>Error loading video details.</p>;
    }

    return (
        <div className="container mx-auto px-4 py-4 lg:px-[5%]">
            <button
                onClick={handleBackClick}
                className="mb-5 text-primary py-2 px-4 rounded hover:underline transition duration-300"
            >
                <ChevronLeft className="mr-2"/>
                Retour
            </button>
            <div className="bg-radar">
                <div className="py-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 justify-center">
                        <div className="relative w-full" style={{paddingBottom: '56.25%'}}>
                            {/* Show iframe if videoUrl is not set, otherwise show the dynamic video */}
                            {videoUrl ? (
                                <iframe
                                    className="absolute top-0 left-0 w-full h-full rounded-xl"
                                    src={videoUrl} // Use videoUrl dynamically
                                    title="Video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                ></iframe>
                            ) : (
                                <iframe
                                    className="absolute top-0 left-0 w-full h-full rounded-xl"
                                    src="https://www.youtube.com/embed/xpIRqdxqDyY?si=d1cZmCyrHnSvfQYb"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                ></iframe>
                            )}
                        </div>

                        <div className="w-full mt-4" style={{background: '#ECEFF1'}}>
                            {video.documents && video.documents.length > 0 && (
                                <div className="mb-4">
                                    <ul className="list-none">
                                        {video.documents.map((fiche) => (
                                            <li key={fiche.id_document}
                                                className="flex items-center justify-between mb-2 p-2 bg-gray-800 rounded-md hover:bg-gray-700 transition duration-200">
                                                {/* Contenu principal à gauche */}
                                                <div className="flex items-center">
                                                    <img src={coverUrl} alt="video"
                                                         className="w-[50px] h-[50px] rounded-xl"/>
                                                    <span className="text-lg text-white ml-4">{fiche.titleFiche}</span>
                                                </div>

                                                {/* Icône à droite */}
                                                <button onClick={() => lireVideo(fiche.file, fiche.typeFiche)}
                                                        className="ml-auto">
                                                    <MoreVertOutlinedIcon style={{fontSize: 20}}
                                                                          className="text-blue-400"/>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mt-4">
                        <h1 className="text-3xl font-bold">{video.title_course}</h1>
                        <p className="mt-2 text-gray-600 text-radar-pub">{video.resume_course}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoDetails;
